module.exports = __webpack_public_path__ + "img/1272.47265e9e.jpg";